import { render, staticRenderFns } from "./CTableBody.vue?vue&type=template&id=6d6b635f&scoped=true&"
import script from "./CTableBody.vue?vue&type=script&lang=ts&"
export * from "./CTableBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6b635f",
  null
  
)

export default component.exports